import { render, staticRenderFns } from "./HomeShopkeeperCard.vue?vue&type=template&id=241e5179&"
import script from "./HomeShopkeeperCard.vue?vue&type=script&lang=js&"
export * from "./HomeShopkeeperCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports